// extracted by mini-css-extract-plugin
export default {"container":"CourseNavigation_container__uHViR"};